import React from 'react'
// import { Admin } from 'ca-admin-core'
import { Provider } from 'react-redux'
import { HelmetProvider } from 'react-helmet-async'
import createReduxStore from './redux/store'

import { Localization, Router } from './admincore'
import MobileViewObserver from './admincore/mobile_view_observer'
// import modules from './modules'

// import TopBar from './components/TopBar'

// import './assets/theme.scss'

const App = () => {
  // const extra = (
  //   <>
  //     <TopBar />
  //   </>
  // )

  return (
    <Provider store={createReduxStore()}>
      {/* <Admin title="Business Dash" modules={modules} topBarExtra={extra} /> */}
      <MobileViewObserver />

      <HelmetProvider>
        <Localization>
          <Router />
        </Localization>
      </HelmetProvider>
    </Provider>
  )
}

export default App
